import { az, enUS } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { setDefaultOptions } from 'date-fns'

export function useDateConfigs() {
  const { i18n } = useTranslation()

  useEffect(() => {
    setDefaultOptions({ locale: i18n.language === 'en' ? enUS : az })
  }, [i18n.language])
}
